"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextButton = TextButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const bind_1 = __importDefault(require("classnames/bind"));
const text_button_m_scss_1 = __importDefault(require("./text-button.m.scss"));
const cx = bind_1.default.bind(text_button_m_scss_1.default);
/**
 * Текстовая кнопка.
 * @param props Свойства.
 * @return Элемент.
 */
function TextButton({ size = 'm', color = 'basic-blue', children, className, startIcon: StartIcon, endIcon: EndIcon, buttonRef, anchorRef, underline, disabled, iconGutter = 8, 'data-testid': testId = 'text-button', ...restProps }) {
    const rooClassName = cx('root', color && color !== 'unset' && `color-${color}`, size && size !== 'unset' && `size-${size}`, typeof iconGutter === 'number' && `icon-gutter-${iconGutter}`, underline && 'underline', disabled && 'disabled', className);
    const content = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [StartIcon && (0, jsx_runtime_1.jsx)(StartIcon, { className: cx('icon-start') }), children, EndIcon && (0, jsx_runtime_1.jsx)(EndIcon, { className: cx('icon-end') })] }));
    let result;
    switch (restProps.as) {
        case 'anchor': {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { as, ...anchorProps } = restProps;
            result = ((0, jsx_runtime_1.jsx)("a", { ...anchorProps, ref: anchorRef, className: rooClassName, "data-testid": testId, children: content }));
            break;
        }
        case 'button':
        default: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { as, ...buttonProps } = restProps;
            result = ((0, jsx_runtime_1.jsx)("button", { ...buttonProps, ref: buttonRef, className: rooClassName, disabled: disabled, "data-testid": testId, children: content }));
            break;
        }
    }
    return result;
}
//# sourceMappingURL=text-button.js.map